import { BaseEntity } from "yt-ng-framework";

export class MesnaZajednica extends BaseEntity{
    constructor(){
        super();
    };

    Naziv:string=null;
    MestoID:number=null;

    Deserialize(input:any){
        this.ID = input.ID;
        this.Naziv=input.Naziv;
        this.MestoID=input.MestoID;
        return this;
    }

    Serialize(input:MesnaZajednica){
        return input;
    }

}